import * as Enumerable from 'linq';


export interface LetterAvatarInfo {
  fontSize: number;
  color: string;
  text: string;
  font: string;
  size: number;
}


export class LetterAvatar {

  public static readonly colors = ['#1abc9c', '#16a085', '#f1c40f', '#f39c12', '#2ecc71', '#27ae60', '#e67e22', '#d35400', '#3498db', '#2980b9', '#e74c3c', '#c0392b', '#9b59b6', '#8e44ad', '#bdc3c7', '#34495e', '#2c3e50', '#95a5a6', '#7f8c8d', '#ec87bf', '#d870ad', '#f69785', '#9ba37e', '#b49255', '#b49255', '#a94136'];

  public static generateSvg(text: string, size: number = 60): string {

    const info = LetterAvatar.generateInfo(text, size);

    const template = [
      '<svg xmlns="http://www.w3.org/2000/svg" height="' + size + '" width="' + size + '" style="border-radius:50%;background: ' + info.color + '">',
      '<text text-anchor="middle" x="50%" y="50%" dy="0.35em" fill="white" font-size="' + info.fontSize + '" font-family="' + info.font + '">' + info.text.toUpperCase() + '</text>',
      '</svg>'
    ];

    return template.join('');
  }

  public static generateInfo(text: string, size: number): LetterAvatarInfo {
    if (!text)
      text = '??';

    // Ensure we have intials
    const split = text.split(' ');
    text = split.length > 1
      ? Enumerable.from(split.map(x => x[0])).take(2).toArray().join('')
      : text;

    const textSize = Math.ceil(size / 2.5);
    const font = 'Proxima Nova, proxima-nova, HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif';
    const colorIndex = Math.floor((text.charCodeAt(0) - 65) % LetterAvatar.colors.length);
    const finalColor = LetterAvatar.colors[colorIndex];

    return {
      fontSize: textSize,
      text: text,
      color: finalColor,
      font: font,
      size: size
    };

  }

}
